module.exports = __webpack_public_path__ + "static/media/Mildred.64d89942.webp";